module.exports = __webpack_public_path__ + "img/united-kingdom.a7fc19d7.png";